<template>
    <div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <b-row>
                    <b-col md="12">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-3 col-form-label text-title">Poliklinik</label>
                            <div class="col-sm-9 form-control-plaintext">
                                : {{ dataRM.transklinik.poli_id }}
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-3 col-form-label text-title">Dokter</label>
                            <div class="col-sm-9 form-control-plaintext">
                                : {{ dataRM.transklinik.dokter ? dataRM.transklinik.dokter.nama : null  }}
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-3 col-form-label text-title">Tanggal Konsultasi</label>
                            <div class="col-sm-9 form-control-plaintext">
                                : {{ dataRM.transklinik.tanggal_konsultasi_formatted }}
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <b-row>
                    <b-col md="12">
                        Last Modified: {{ dateLastModified(dataRM.updated_at) }}
                        <br>
                        by <span class="text-title">{{ dataRM.updated_by }}</span>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "Poliklinik",
        props: ["dataRM"],
        mounted() {},
        watch: {},
        methods: {
            dateLastModified(d) {
                return moment(d).format('MMM DD, YYYY @ HH:mm')
            },
        }
    }
</script>

<style>
    .mb-header {
        margin-bottom: -15px;
    }
</style>